import { render, staticRenderFns } from "./canvas-item.vue?vue&type=template&id=9eb1d590"
import script from "./canvas-item.vue?vue&type=script&lang=js"
export * from "./canvas-item.vue?vue&type=script&lang=js"
import style0 from "./canvas-item.vue?vue&type=style&index=0&id=9eb1d590&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports